<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:append="{ row }">
        <el-tag size="mini" :type="row.isAppend === 'Y' ? '' : 'info'">
          {{ row.v_isAppend }}
        </el-tag>
      </template>
      <template v-slot:expenseStatus="{ row }">
        <el-tag
          v-if="row.shipmentExpenseStatus"
          size="mini"
          :type="
            row.shipmentExpenseStatus === 'Y'
              ? 'success'
              : row.shipmentExpenseStatus === 'S'
              ? 'warning'
              : row.shipmentExpenseStatus === 'D' ||
                row.shipmentExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_shipmentExpenseStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openDetailPage', {
                  pageType: 'detail',
                  params: { code: row.shipmentPayStatementCode },
                  query: { shipmentPayStatementNo: row.shipmentPayStatementNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_submitPayRequest') || '提交请款'"
            placement="top"
            v-if="allow('S') && !row.shipmentExpenseStatus"
          >
            <i
              class="el-icon-check tool-btn"
              @click="submitPayRequest(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.Rejected') || '驳回'"
            placement="top"
            v-if="allow('R') && !row.shipmentExpenseStatus"
          >
            <i class="el-icon-close tool-btn" @click="rejectReview(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    rejectReview({ shipmentPayStatementCode }) {
      this.$confirm(
        '是否驳回该结算单审核申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .shipmentPayStatementRejectReviewApi({ shipmentPayStatementCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (200 !== status) {
          this.$message.error('驳回失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '驳回成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    submitPayRequest(e) {
      this.$emit('submitPayRequest', e)
    },
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckBoxRow() {
      this.$refs.table.clearCheckboxRow()
    },
  },
}
</script>
